// tm/transactions/updload'

import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const BulkTransactionMonitoringContext = createContext(null);

type Props = {
  children: ReactElement;
};

const BulkTransactionMonitoringProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { mutateAsync, data, isPending, error, reset } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("tm/transactions/upload", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const {
    mutateAsync: mutateAsyncScan,
    data: dataScan,
    isPending: isPendingScan,
    error: errorScan,
    reset: resetScan,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("tm/transactions/upload-scan", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
      reset,
      mutateAsyncScan,
      dataScan,
      isPendingScan,
      errorScan,
      resetScan,
    }),
    [
      mutateAsync,
      data,
      error,
      isPending,
      reset,
      mutateAsyncScan,
      dataScan,
      isPendingScan,
      errorScan,
      resetScan,
    ],
  );
  return (
    <BulkTransactionMonitoringContext.Provider value={contextValue}>
      {children}
    </BulkTransactionMonitoringContext.Provider>
  );
};

export default BulkTransactionMonitoringProvider;
